import React from 'react';
import { useLocation } from 'react-router-dom';

import './NoMatch.scss';

// HOC qui injecte `location` (compatible v5.1+ et v6). Fallback -> window.location.
const withLocation = (Component) => (props) => {
  let loc;
  try {
    loc = useLocation(); // ok si dans un Router
  } catch {
    // fallback si pas de Router
    if (typeof window !== 'undefined' && window.location) {
      const { pathname, search, hash, href } = window.location;
      loc = { pathname, search, hash, href };
    } else {
      loc = { pathname: '', search: '', hash: '', href: '' };
    }
  }
  return <Component {...props} location={loc} />;
};

class NoMatch extends React.PureComponent {
  render() {
    const { location } = this.props;
    const requestedPath =
      (location?.pathname || '') + (location?.search || '') + (location?.hash || '');
    const fullUrl = location?.href ||
      (typeof window !== 'undefined' && window.location ? window.location.href : '');

    // link "Accueil" based  on PUBLIC_URL (CRA) if available
    const PUBLIC_URL = (typeof process !== 'undefined' && process.env && process.env.PUBLIC_URL) || '/';
    const homeHref = `${String(PUBLIC_URL).replace(/\/$/, '')}/`;

    return (
      <div className="not-found page-wrap d-flex flex-row align-items-center">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 text-center">
              <span className="display-1 d-block">404</span>
              <div className="mb-2 lead" > <span role="img" aria-label="warning">⚠️</span> The page you are looking for was not found.</div>
              {requestedPath ? (
                <p className="text-muted mb-3">
                  Requested URL:&nbsp;
                  <code>{requestedPath}</code>
                  {fullUrl && fullUrl !== requestedPath ? (
                    <>
                      <br />
                      <small>(Full URL:&nbsp;<code>{fullUrl}</code>)</small>
                    </>
                  ) : null}
                </p>
              ) : null}

              {/* Optional : back link */}
              <a href={homeHref} className="btn btn-primary mt-2">
                Go to homepage
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withLocation(NoMatch);
